import { createContext } from 'react'
import type { PartnerTier, Profile } from '@/lib/supabase'
import type { Session } from '@supabase/supabase-js'

export interface AuthValue {
  session: Session | null
  profile: Profile | null
  loading: boolean
  /** Ki Tua o Matariki staff or admin. */
  isKtm: boolean
  isKtmAdmin: boolean
  isOrgAdmin: boolean
  /** The organisation's subscription currently allows portal access (R7). */
  hasPortalAccess: boolean
  tier: PartnerTier | null
  /** Does the caller's tier reach this level? Used for locked badges (R14). */
  meetsTier: (required: PartnerTier) => boolean
  signOut: () => Promise<void>
  refreshProfile: () => Promise<void>
}

export const AuthContext = createContext<AuthValue | null>(null)
